import type { Instance } from 'tinycolor2';

export function toTailwindString(color: Instance) {
  const { h, s, l } = color.toHsl();

  return `${h} ${s * 100}% ${l * 100}%`;
}
